import SAlert from 'react-s-alert';

export const openSelectedIfUrl = ({ name, value }: any) => {
  if (name && value && typeof value === 'string' && name.toLowerCase().includes('url')) {
    try {
      const url = new URL(value);
      const newTab = window.open(url, '_blank', 'noopener,noreferrer');
      if (newTab) {
        newTab.opener = null;
      }
    } catch (err) {
      SAlert.error(err);
    }
  }
};
